import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

type Resp = { resumen: { total: number; porSeveridad: Record<string, number> } };

/**
 * Banner que muestra cuántos items no verificados hay en la página actual
 * y enlaza a /fuentes/noverificadas?pagina=...
 */
export function BannerFuentes({ pagina }: { pagina: string }) {
  const { data } = useQuery({
    queryKey: ["fuentes-pagina", pagina],
    queryFn: async () =>
      (await api.get<Resp>("/fuentes/noverificadas", { params: { pagina } })).data,
    staleTime: 5 * 60_000,
  });

  if (!data || data.resumen.total === 0) return null;

  const alta = data.resumen.porSeveridad.alta ?? 0;
  const total = data.resumen.total;

  return (
    <div className="mt-4 rounded-lg border border-sem-contradiccion/40 bg-sem-contradiccion/5 p-3 text-sm">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="text-ink-100">
          <strong className="text-sem-contradiccion">⚠ Auditoría editorial:</strong>{" "}
          {total} {total === 1 ? "afirmación" : "afirmaciones"} en esta página sin verificación
          primaria{" "}
          {alta > 0 && (
            <span className="text-sem-contradiccion font-semibold">({alta} severidad alta)</span>
          )}
        </div>
        <Link
          to={`/fuentes/noverificadas?pagina=${encodeURIComponent(pagina)}`}
          className="rounded-md border border-sem-contradiccion/40 px-3 py-1 text-xs text-sem-contradiccion hover:bg-sem-contradiccion/10"
        >
          Ver detalle →
        </Link>
      </div>
    </div>
  );
}
